import surveyV1 from './surveys/surveyV1';
import surveyV2 from './surveys/surveyV2';

export const surveys = [surveyV1, surveyV2];

export const getLatestVersionId = () => {
  const { version } = surveys.reduce((prev, current) => ((prev.version > current.version) ? prev : current));
  return version;
};
